import { Texture } from "@/core/backends/webgl/texture"
import { Renderer } from "@/core/pipeline/renderer"
import { RawInfo } from "@/lib/raw/fastlib"
import { vec2, vec3, vec4 } from "gl-matrix"
import { HighlightsReconstruction } from "../highlights-reconstruction"
import { DualBuffers } from "@/core/pipeline/dual-buffers"

export interface RawDemosaicerOptions {
	isHalfSize: boolean

	globalOffset: vec2
	croppedSize: { x: number; y: number; width: number; height: number }

	info: RawInfo

	outputWidth: number
	outputHeight: number
	whiteBalanceMultipliers: vec3
	levels: vec2
	cfaArray: vec4

	highlightsReconstruction: HighlightsReconstruction
}

export abstract class RawDemosaicer {
	abstract demosaicHalfSize(
		inputTexture: Texture,
		buffers: DualBuffers,
		renderer: Renderer,
		options: RawDemosaicerOptions,
	)
	abstract demosaicFullSize(
		inputTexture: Texture,
		buffers: DualBuffers,
		renderer: Renderer,
		options: RawDemosaicerOptions,
	)

	demosaic(
		inputTexture: Texture,
		buffers: DualBuffers,
		renderer: Renderer,
		options: RawDemosaicerOptions,
	) {
		if (options.isHalfSize) {
			this.demosaicHalfSize(inputTexture, buffers, renderer, options)
		} else {
			this.demosaicFullSize(inputTexture, buffers, renderer, options)
		}
	}
}
